export default "/images/4a23fd7475d94745f7a8bb7befc2e0f5.avif";